<template>
  <a-modal
    :visible="visible"
    @cancel="handleModalCancel"
    width="520px"
    :footer="false"
    centered
    :maskClosable="false"
  >
    <div class="modal-content">
      <h2 class="modal-title">
        ¡Recomienda Beex y gana hasta 
        <span class="highlight">$300 en giftcards!</span> 🎉
      </h2>

      <p class="modal-subtitle">
        Conecta a empresas con Beex, nosotros los contactamos y recibe una 
        giftcard de $50 a $300 por cada referido que se convierta en cliente.
      </p>
      <p class="title-benefits">Beneficios de participar:</p>
      <!-- Beneficios -->
      <div class="benefits">
        <div class="benefit">
          <img :src="gift" alt="gift" />
          <p>Recibe tu giftcard compartiendo un referido.</p>
        </div>
        <div class="benefit">
          <img :src="graficGoesUp" alt="chart" />
          <p>Mientras más refieras, más ganas. ¡No hay límite!</p>
        </div>
        <div class="benefit">
          <img :src="handsShake" alt="handshake" />
          <p>Ayuda a empresas a mejorar su atención al cliente.</p>
        </div>
      </div>

      <!-- Pasos -->
      <div class="steps">
        <p class="title-benefits">Participa siguiendo estos pasos:</p>
        <ol>
          <li>Completa el formulario con los datos del referido.</li>
          <li>Nuestro equipo se comunicará con el referido para presentarle Beex.</li>
          <li>Si el referido se convierte en cliente, recibirás una giftcard.</li>
        </ol>
      </div>

      <!-- Botón -->
      <div class="footer">
        <button class="modal-button" @click="handleRegister">
          ¡Refiere ahora y empieza a ganar!
        </button>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import gift from "../../assets/gift.svg?url";
import graficGoesUp from "../../assets/grafic-goes-up.svg?url";
import handsShake from "../../assets/hands-shake.svg?url";
import ModalRegisterBenefits from "./ModalRegisterBenefits.vue";
import { updateUser } from "@/app/users/services";
import { useStore } from "vuex";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});

const store = useStore();
const visibleModalRegister = ref(false);
const emit = defineEmits(["update:visible", "openRegisterNewBenefit"]);
const handleModalOpen = () => {
  visibleModalRegister.value = true;
};
const user_id = Number(localStorage.getItem("used_id"));

const handleModalCancel = () => {
  handleViewFirstTime();
  emit('update:visible', false)
  visibleModalRegister.value = false;
};
const handleViewFirstTime = async () => {
  try{
    const body = {
      show_referral_banner: false,
    };
    await updateUser(user_id, body);
    await store.dispatch("fetchDataUser");
  } catch (error) {
    console.error("Error marking referral modal as viewed:", error);
  }
};
const handleRegister = async () => {
  console.log("Botón de referir clickeado", visibleModalRegister.value);
  // handleModalOpen();
  handleViewFirstTime();
  emit("openRegisterNewBenefit");
  emit('update:visible', false);
};
onMounted(async () => {
  await store.dispatch("fetchDataUser");
  // await handleViewFirstTime();
});
</script>

<style lang="sass" scoped>
.modal-content 
  padding: 1rem

.modal-title 
  font-size: 24px
  font-weight: 600
  text-align: center
  margin-bottom: 0.5rem

.modal-subtitle 
  text-align: center
  color: #555
  margin-bottom: 1.5rem

.title-benefits
  font-size: 16px
  font-weight: 600
  display: flex
  justify-content: center

.benefits 
  display: flex
  justify-content: space-between
  margin-bottom: 1.5rem

  .benefit 
    flex: 1
    text-align: center
    padding: 0 0.5rem

    img 
      width: 78px
      height: 78px
      margin-bottom: 0.5rem
    
    p 
      font-size: 14px
      color: #444
    
.steps 
  margin-bottom: 1.5rem
  h3 
    font-weight: 600
    margin-bottom: 0.5rem
  
  ol 
    padding-left: 1.2rem
    li 
      margin-bottom: 0.3rem
      color: #555
      font-size: 14px

.footer
  display: flex
  justify-content: center

.modal-button 
  background: rgba(22, 119, 255, 1)
  color: #fff
  padding: 0.4rem 10.4px
  border: none
  border-radius: 8px
  font-size: 1rem
  cursor: pointer
  transition: background 0.2s ease
  &:hover 
    background: #1d4ed8
</style>